module.exports = __webpack_public_path__ + "img/circle-highlight.6b35fb2b.svg";